<div [ngSwitch]="getSwitchExpression()">
    <span *ngSwitchCase="'ACTIVE_WITH_SUBSCRIPTION_IN_FUTURE'" class="has-font-100 color-grey-500" data-cy="automatic-extension-text">Automatische Verlängerung der Anzeige <br/> am {{runtimeUntilReadable}} um deine anfangs gewählte Laufzeit.</span>
    <span *ngSwitchCase="'INACTIVE_WITH_SUBSCRIPTION_IN_FUTURE'" class="has-font-100 color-grey-500">Dein gewähltes Paket läuft am {{runtimeUntilReadable}} ab.<br/> Um dein Paket zu verlängern, aktiviere deine Anzeige.</span>
    <span *ngSwitchDefault class="has-font-100 color-grey-500"></span>
</div>

